<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar class="mb-2"></medsurf-navbar>
  <!-- Content -->
  <div class="flex flex-1 overflow-auto justify-content-center align-self-center w-11 lg:w-5 mb-2">
    @if (metadataForm) {
      <medsurf-design-form-control-form
        class="w-full"
        [formGroup]="metadataForm"
        (onSubmit)="onSubmit()">
        <div class="flex flex-column row-gap-2">
          <!-- Start Page Panel -->
          <medsurf-design-content-panel titleText="global.start_page">
            <!-- Carousel Title -->
            <medsurf-design-form-control-input-text #carouselTitleInputText
              [control]="metadataForm.controls.carouselTitle"
            label="global.title"></medsurf-design-form-control-input-text>
            <!-- Carousel Copyright -->
            <medsurf-design-form-control-input-text [control]="metadataForm.controls.carouselCopyright"
            label="global.copyright"></medsurf-design-form-control-input-text>
            <!-- Carousel Text Color -->
            <medsurf-design-form-control-input-color-picker [control]="metadataForm.controls.carouselTextColor"
            label="global.text_color"></medsurf-design-form-control-input-color-picker>
            <!-- Carousel Show Subjects -->
            <medsurf-design-form-control-input-switch [control]="metadataForm.controls.carouselShowSubjects"
            label="global.subjects_show"></medsurf-design-form-control-input-switch>
            <!-- Submit -->
            <medsurf-design-form-control-input-submit [disabled]="metadataForm.invalid || isSubmitted()"
            label="global.save_changes"></medsurf-design-form-control-input-submit>
          </medsurf-design-content-panel>
          <!-- Html Panel -->
          <medsurf-design-content-panel titleText="global.html_metadata">
            <!-- Title -->
            <medsurf-design-form-control-input-text [control]="metadataForm.controls.title"
            label="global.title"></medsurf-design-form-control-input-text>
            <!-- Keywords -->
            <medsurf-design-form-control-input-text [control]="metadataForm.controls.keywords"
            label="global.keywords"></medsurf-design-form-control-input-text>
            <!-- Description -->
            <medsurf-design-form-control-input-textarea [control]="metadataForm.controls.description"
            label="global.description"></medsurf-design-form-control-input-textarea>
            <!-- Support Email -->
            <medsurf-design-form-control-input-text [control]="metadataForm.controls.supportEmail"
            label="global.support_email"></medsurf-design-form-control-input-text>
            <!-- Submit -->
            <medsurf-design-form-control-input-submit [disabled]="metadataForm.invalid || isSubmitted()"
            label="global.save_changes"></medsurf-design-form-control-input-submit>
          </medsurf-design-content-panel>
          <!-- Start Image Panel -->
          <medsurf-design-content-panel titleText="global.cover_image">
            <!-- Media -->
            <medsurf-media-library-modal [mediaId]="metadataForm.value.carouselMedia"
                                         [allowedTypes]="[
                                           FlatModels.MediaEntityModels.MediaType.enum.MediaImage,
                                           FlatModels.MediaEntityModels.MediaType.enum.MediaDeepzoom
                                         ]"
                                         class="w-full"
                                         (mediaChange)="onMediaChange($event)"></medsurf-media-library-modal>
          </medsurf-design-content-panel>
        </div>
      </medsurf-design-form-control-form>
    }
  </div>
</div>


